import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Coins, ArrowUpRight } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { useI18n } from '../i18n';

export default function EdenWallet() {
  const { user } = useAuth();
  const { t } = useI18n();
  const [state, setState] = useState({ balance: null, failed: false });
  const uid = user?.user_id;
  const guest = user?.is_guest;
  useEffect(() => {
    let active = true;
    let revision = 0;
    setState({ balance: null, failed: false });
    if (!uid || guest) return undefined;
    const load = async () => {
      const current = ++revision;
      try {
        const { data } = await api.get('/eden/garden/summary');
        if (active && current === revision) setState({ balance: data.muld_coins, failed: false });
      } catch {
        if (active && current === revision) setState({ balance: null, failed: true });
      }
    };
    load();
    window.addEventListener('eden:wallet-changed', load);
    window.addEventListener('focus', load);
    return () => {
      active = false;
      window.removeEventListener('eden:wallet-changed', load);
      window.removeEventListener('focus', load);
    };
  }, [uid, guest]);
  if (!uid || guest) return null;
  return (
    <Link to="/eden" data-testid="eden-wallet" className="mb-5 flex items-center gap-3 rounded-2xl border border-brand-border bg-brand-card p-4 text-brand-ink">
      <Coins size={24} className="text-brand-ochre shrink-0" aria-hidden="true" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-sm" aria-live="polite">
          {state.failed ? t('eden.wallet_unavailable') : `${state.balance ?? '…'} ${t('plant.bridge_coins')}`}
        </p>
        <p className="text-xs text-brand-ink3 mt-1">{t('eden.wallet_note')}</p>
      </div>
      <ArrowUpRight size={18} aria-hidden="true" />
    </Link>
  );
}
